export default {
	START_TYPING_AN_ADDRESS: 'Start typing an address..',
	NOT_SAVED: '[NOT SAVED] ',
	MARKER_ON_ADDRESS: 'Marker on address: ',
	CURRENT_CITY: 'Current city:',
	CURRENT_ADDRESS: 'Current address:',
	ZERO_RESULTS: 'Can not retrieve location, incorrect address / zip code!',
	OVER_QUERY_LIMIT: 'Too many requests at the sametime, try again later...',
	UNKNOWN_ERROR: 'Address not found'
};